

function productSlideShowAdapt() {
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;
    const productMediaContainer = document.querySelector('.product--thumbnails-left');
    const productImgs = productMediaContainer?.querySelectorAll('.product__media-image-wrapper');
    const isWideScreen = screenWidth >= 1400 && screenWidth <= 1800 && screenHeight < 800;
    const isDesktop = screenWidth >= 760;
    const isLargeScreenWide = screenWidth >= 1200 && isDesktop;
    const isHeightGreaterThan760 = screenHeight > 760;

    if (isWideScreen) {
        productMediaContainer.classList.add('two-img-enabled');
        productImgs.forEach(img => {
            img.classList.remove('aspect-ratio', 'aspect-ratio--natural');
            img.classList.add('no-ratio');
        });
    } else {
        productMediaContainer.classList.remove('two-img-enabled');
        productImgs.forEach(img => {
            img.classList.remove('no-ratio');
            img.classList.add('aspect-ratio', 'aspect-ratio--natural');
        });
    }

    if (isLargeScreenWide && isHeightGreaterThan760) {
        productMediaContainer.classList.add('adabt-height-enabled');
        productImgs.forEach(img => {
            img.classList.remove('aspect-ratio', 'aspect-ratio--natural');
            img.classList.add('no-ratio');
        });
    } else {
        productMediaContainer.classList.remove('adabt-height-enabled');
        productImgs.forEach(img => {
            img.classList.remove('no-ratio');
            img.classList.add('aspect-ratio', 'aspect-ratio--natural');
        });
    }

}

productSlideShowAdapt();
window.addEventListener('resize', productSlideShowAdapt);

